import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { Busyable } from 'src/app/shared/editors/busyable';

@Component({
    selector: 'app-citations-requiring-action',
    templateUrl: './citations-requiring-action.component.html',
    styleUrls: ['./citations-requiring-action.component.scss'],
    standalone: false
})
export class CitationsRequiringActionComponent extends Busyable implements OnInit {
  availableSteps: any[] = [];
  selectedStepId: number | null = null;
  citations: any[] = [];
  selectedCitations: Set<number> = new Set();
  selectAll = true;

  constructor(private api: ApiService) {
    super();
  }

  async ngOnInit(): Promise<void> {
    await this.loadAvailableSteps();
  }

  async loadAvailableSteps(): Promise<void> {
    this.Loading();
    try {
      const response = await this.api.Get<any>("enforcement/citations/requireaction/availableSteps");
      this.availableSteps = response.AvailableSteps || [];
    } catch (error) {
      console.error('Error loading available steps:', error);
    } finally {
      this.StopLoading();
    }
  }

  async onStepSelected(event: Event): Promise<void> {
    const select = event.target as HTMLSelectElement;
    const stepId = parseInt(select.value);
    if (isNaN(stepId)) return;
    
    this.selectedStepId = stepId;
    this.Loading();
    try {
      const response = await this.api.Get<any>(`enforcement/citations/requireaction/${stepId}`);
      this.citations = response.Citations;
      // Select all citations by default
      this.selectedCitations = new Set(this.citations.map(c => c.Id));
      this.selectAll = true;
    } catch (error) {
      console.error('Error loading citations for step:', error);
    } finally {
      this.StopLoading();
    }
  }

  toggleSelectAll(): void {
    this.selectAll = !this.selectAll;
    if (this.selectAll) {
      this.selectedCitations = new Set(this.citations.map(c => c.Id));
    } else {
      this.selectedCitations.clear();
    }
  }

  toggleCitationSelection(citationId: number): void {
    if (this.selectedCitations.has(citationId)) {
      this.selectedCitations.delete(citationId);
    } else {
      this.selectedCitations.add(citationId);
    }
    this.selectAll = this.selectedCitations.size === this.citations.length;
  }

  isCitationSelected(citationId: number): boolean {
    return this.selectedCitations.has(citationId);
  }

  getSelectedStepName(): string {
    if (!this.selectedStepId) return '';
    const step = this.availableSteps.find(s => s.Id === this.selectedStepId);
    return step ? step.Name : '';
  }

  async actionSelectedCitations(): Promise<void> {
    if (!this.selectedStepId || this.selectedCitations.size === 0) return;

    this.Loading();
    try {
      const response = await this.api.Post<any>(`enforcement/citations/requireaction/${this.selectedStepId}/action`, {
        ActionCitationIds: Array.from(this.selectedCitations)
      });
      // Update citations directly from the response
      this.citations = response.Citations;
      // Reset selection state
      this.selectedCitations = new Set(this.citations.map(c => c.Id));
      this.selectAll = true;
    } catch (error) {
      console.error('Error actioning citations:', error);
    } finally {
      this.StopLoading();
    }
  }
} 
